<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="''"
        :subTitle="''"
        :switch-text="''"
        :has-back="false"
        :businessType="businessType"
      >
        <template #form>
          <h1 class="main-title">{{ $t('login.hr_bind.title') }}</h1>
          <div class="sub-desc">
            {{ $t('login.hr_bind.desc') }}
          </div>
          <el-form ref="staffFormRef" :model="form" :rules="rules">
            <el-form-item prop="name">
              <base-input
                v-model="form.name"
                @focus="loading = false"
                :placeholer="$t('login.hr_bind.namePlaceholder')"
              ></base-input>
            </el-form-item>
            <el-form-item prop="id">
              <base-input
                v-model="form.id"
                @focus="loading = false"
                :placeholer="$t('login.hr_bind.jobNumberPlaceholder')"
              ></base-input>
            </el-form-item>
            <el-form-item prop="code">
              <base-input
                v-model="form.code"
                @focus="loading = false"
                :placeholer="$t('login.hr_bind.secretPlaceholder')"
              ></base-input>
            </el-form-item>
            <el-form-item prop="">
              <el-button
                type="primary"
                class="main-button"
                @click="handleSubmit"
                >{{ $t('login.hr_bind.confirm') }}</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>

<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import BaseInput from '@/components/common/BaseInput.vue'
import { getBusinessType } from '@/constant'
import { mapGetters } from 'vuex'
import handleSaveAndJump from '@/utils/saveLogin'
import hrService from '@/http/porsche-hr'
import _throttle from 'lodash/throttle'

export default {
  components: { BaseInput, LoginLayout, LoginContainer },
  data() {
    return {
      loading: false,
      form: {
        name: '', // 名称
        id: '', // 工号
        code: '', // 秘钥
      },
    }
  },
  computed: {
    ...mapGetters(['loginResultData']),
    businessType() {
      return getBusinessType().id
    },
    rules() {
      return {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('login.hr_bind.namePlaceholder'),
          },
          {
            min: 2,
            trigger: 'blur',
            message: this.$t('login.hr_bind.nameLimit'),
          },
        ],
        id: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('login.hr_bind.jobNumberPlaceholder'),
          },
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('login.hr_bind.secretPlaceholder'),
          },
        ],
      }
    },
  },
  created() {
    if (!this.loginResultData) {
      this.$router.replace({
        path: 'hr',
        query: { ...this.$route.query },
      })
    }
  },
  methods: {
    handleSubmit: _throttle(
      function () {
        if (this.loading) return
        this.$refs['staffFormRef'].validate(async (valid) => {
          if (valid) {
            try {
              this.loading = true
              const res = await hrService.setStaffInfo({ ...this.form })
              if (res.code === 0) {
                this.$message.success(this.$t('login.loginPage.success'))
                this.loading = false
                handleSaveAndJump(this.loginResultData)
              }
            } catch (e) {
              const _this = this
              setTimeout(() => {
                _this.loading = false
              }, 3000)
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
  },
}
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 160% */
  margin-bottom: 8px;
  color: #000;
  text-align: center;
}
.sub-desc {
  color: #565656;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-bottom: 16px;
  white-space: pre-line;
}
.main-button {
  border-radius: 12px;
  background: linear-gradient(
      180deg,
      #e97a89 -14.96%,
      #e24a5e 30.92%,
      #dc253d 100%
    ),
    #d5001c;
  font-size: 16px;
  color: #f7f7fc !important;
  font-weight: 700;
  border: none;
  height: 52px;
  box-sizing: border-box;
  width: 100%;
}
</style>
